import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { nanoid } from 'nanoid'
import MutableConnect from '../../utils/MutableConnect'
import Switch from "../inputs/SwitchPdi"
import PatientPDIHeaderTableRow from './PatientPDIHeaderTableRow'
import PatientPDIContentTableRow from './PatientPDIContentTableRow'
import { getStatusOfPDI } from '../../utils/DataHelper'
import visibleForRole from '../../hocs/visibleForRole'
import withRouter from '../wrapperReactRouterDom'

class PatientPDIStatusTable extends Component {
  render() {
    const { pdiList, router } = this.props
    // eslint-disable-next-line camelcase
    const { study_id, patient_id } = router.params
   
    return (
      <div className="o-table pdi-status-table">
        <table>
          <tbody>
            <PatientPDIHeaderTableRow tableHeaders={ ["Type", "Description", "Status"] } />
            {
              pdiList.map(pdi => (
                <PatientPDIContentTableRow key={ nanoid() } tableContent={ [pdi.type, pdi.description, this._renderStatusAndToggle(pdi.active, pdi.id, pdi.description, pdi.type, pdi.canBeDeactivated, study_id, patient_id)] } />
              ))
                }
          </tbody>
        </table>
      </div>
    )
  }

  _renderStatusAndToggle = (status, reference, description, type, canBeDeactivated, studyId, patientId) => {
    const PdiSwitch = visibleForRole(["investigator", "site_user"],
      <Switch
        className="react-switch-pdi-status"
        checked={ status }
        description={ description }
        reference={ reference }
        type={ type }
        studyId={ studyId }
        patientId={ patientId }
      />)

    return (
      <div className="pdi-status">
        { getStatusOfPDI(status) }
        { !!canBeDeactivated && <PdiSwitch /> }
      </div>
    )
  }
}

export const mapStateToProps = state => ({ pdiList: state.pdis.pdiList })

PatientPDIStatusTable.propTypes = {
  pdiList: PropTypes.array,
  router: PropTypes.object.isRequired,
}

PatientPDIStatusTable.defaultProps = { pdiList: [] }

export default withRouter(MutableConnect(mapStateToProps, null)(PatientPDIStatusTable))
